module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-387.7141122.woff2";